import { Route } from "react-router-dom";
import ProviderClientList from "../components/index";
import ProviderMiddleware from "../../provider-middleware/components";

const ProviderClientListiRoutes = () => (
  <>
    <Route path="client-list" element={<ProviderMiddleware><ProviderClientList /></ProviderMiddleware>} />
  </>
);


export default ProviderClientListiRoutes;